import React from "react";
import FormHelperText from "@mui/material/FormHelperText";
import classNames from "classnames";
import { withPopoverText } from "../Utilities/HelperTextHelper";
export const ErrorHandlingFormHelperText = props => {
  const {
    id,
    error,
    disabled,
    helperText,
    popoverText,
    customHelperIcon,
    errorMessage,
    className
  } = props;
  const messageText = error ? errorMessage : withPopoverText(helperText, popoverText, customHelperIcon);
  return /*#__PURE__*/React.createElement(React.Fragment, null, (messageText || error && errorMessage) && /*#__PURE__*/React.createElement(FormHelperText, {
    id: `${id}-helper-text`,
    error: error,
    disabled: disabled,
    className: classNames("prmbl-errorHandlingFormHelperText", className),
    variant: "standard"
  }, messageText));
};
export default ErrorHandlingFormHelperText;